import { environment } from '@quartz-iam-legacy/environments/environment';

(function () {
	'use strict';

	angular
        .module('personModule')
        .factory('personService', service);

	service.$inject = ['$http', '$q'];

	function service($http, $q) {
	    var baseUrl = environment.apiUrl + '/ID/API/Person';

		var service = {
		    getPersonByID: getPersonByID,
		};
		return service;

		////////////

	    // Get person by id
		function getPersonByID(personId) {
		    var reqUrl = baseUrl + '/' + personId;

		    return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}
	}
})();
